import { createSelector } from 'reselect';
import { getTrackAssetsSelector } from 'redux/modules/embed/selectors';

export const trackSizeSelector = (trackId: string) =>
  createSelector([getTrackAssetsSelector(trackId)], trackAssets => {
    const isAutoframed =
      trackAssets.find(asset => asset.type === 'autoframed-video') !==
      undefined;

    return isAutoframed ? 'expanded' : 'normal';
  });
